import { render, staticRenderFns } from "./PortfolioCarousel.vue?vue&type=template&id=a0d8c98c&scoped=true&"
import script from "./PortfolioCarousel.vue?vue&type=script&lang=js&"
export * from "./PortfolioCarousel.vue?vue&type=script&lang=js&"
import style0 from "./PortfolioCarousel.vue?vue&type=style&index=0&id=a0d8c98c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a0d8c98c",
  null
  
)

export default component.exports